import { Link } from 'react-router-dom';
import { Compass, ArrowRight } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-primary/5 to-white flex items-center justify-center p-4">
      <div
        className="bg-white border border-border rounded-2xl shadow-lg max-w-lg w-full p-8 text-center space-y-4"
        data-testid="not-found-page"
      >
        <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
          <Compass className="w-9 h-9 text-primary" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground" data-testid="not-found-h1">
          Pagina niet gevonden
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Deze link bestaat niet (meer). Mogelijk is hij verouderd of verkeerd ingetypt.
        </p>
        <div className="space-y-2 pt-2">
          <Link
            to="/energy-control-intake"
            className="w-full inline-flex items-center justify-center gap-1 px-4 py-3 rounded-md bg-primary text-white text-sm font-semibold hover:bg-primary/90"
            data-testid="not-found-cta-intake"
          >
            Start Energy Control · € 9,95/m eerste 3 mnd <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/"
            className="w-full inline-flex items-center justify-center gap-1 px-4 py-3 rounded-md border border-border text-sm font-semibold hover:bg-muted"
            data-testid="not-found-cta-home"
          >
            Terug naar home
          </Link>
        </div>
        <p className="text-[11px] text-muted-foreground pt-2">
          Maandelijks opzegbaar · geen leverancierswissel · geen verkoper aan de deur
        </p>
      </div>
    </div>
  );
}
